"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSpinner = _styledComponents.default.div.withConfig({
  displayName: "LoadingSpinner",
  componentId: "hzhtuu-0"
})(["animation:rotate 1s linear infinite;border:", "px solid ", ";border-left-color:", ";width:", "px;height:", "px;border-radius:50%;@keyframes rotate{100%{transform:rotate(360deg);}}"], function (_ref) {
  var stroke = _ref.stroke;
  return stroke || 4;
}, function (_ref2) {
  var barColor = _ref2.barColor;
  return (0, _helpers.color)(barColor || 'white');
}, function (_ref3) {
  var c = _ref3.color;
  return (0, _helpers.color)(c || 'dark-1');
}, function (_ref4) {
  var radius = _ref4.radius;
  return radius * 2 || 20;
}, function (_ref5) {
  var radius = _ref5.radius;
  return radius * 2 || 20;
});

var _default = LoadingSpinner;
exports.default = _default;